"use client";

import { useId, useState } from "react";
import styles from "./SplitFeature.module.css";
import type { SplitFeatureItem } from "./SplitFeature.types";

/** Liste d'arguments à filets ; les items avec `description` forment un accordéon (un seul ouvert). */
export function SplitFeatureList({ items, defaultOpen }: { items: ReadonlyArray<SplitFeatureItem>; defaultOpen?: number }) {
  const [open, setOpen] = useState<number | null>(defaultOpen ?? null);
  const baseId = useId();
  return (
    <ul className={styles.list}>
      {items.map((item, index) => {
        const expandable = item.description !== undefined;
        const isOpen = expandable && open === index;
        const panelId = `${baseId}-panel-${index}`;
        return (
          <li key={index} className={styles.item} data-open={isOpen ? "true" : "false"} data-icon={item.icon ? "true" : "false"}>
            {expandable ? (
              <button
                type="button"
                className={`${styles.row} ${styles.trigger}`}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? null : index)}
              >
                {item.icon ? <span className={styles.icon} aria-hidden="true">{item.icon}</span> : null}
                <span className={styles.label}>{item.title}</span>
                <span className={styles.chevron} aria-hidden="true" />
              </button>
            ) : (
              <div className={styles.row}>
                {item.icon ? <span className={styles.icon} aria-hidden="true">{item.icon}</span> : null}
                <span className={styles.label}>{item.title}</span>
              </div>
            )}
            {expandable ? (
              <div id={panelId} className={styles.panel} role="region" aria-hidden={!isOpen}>
                <div className={styles.panelInner}>
                  <p className={styles.panelText}>{item.description}</p>
                </div>
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
